import { TableCell } from '@material-ui/core'
import { TrackingRows } from '@types'

interface TableCellProps {
  row: TrackingRows
  openEditStages: () => void
  children: string
}

const TableCellComponent: React.FC<TableCellProps> = ({ openEditStages, children }) => {
  return (
    <TableCell
      onClick={openEditStages}
      align="center"
      style={{
        color: '#000'
      }}
    >
      {children}
    </TableCell>
  )
}

export default TableCellComponent
